module.exports = __webpack_public_path__ + "img/report-pdf.0fb0058.png";